module.exports = __webpack_public_path__ + "img/file-video.b25c1be3.svg";